import React, { useLayoutEffect, useState, useEffect } from 'react'
import { useNavigate , useSearchParams } from 'react-router-dom'
import axios from 'axios'
import URL from '../constants/ServerUrl'

const EditUser = ({ route }) => {
  // all the states
  const [userId, setUserId] = useState('')
  const [mobileNo, setMobileNo] = useState()
  const [contactPerson, setContactPerson] = useState('')
  const [address, setAddress] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false)
  const navigator = useNavigate()
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const token = localStorage.getItem("dairy-token")
  const [allowAddFarmer, setAllowAddFarmer] = useState('Not Allow')
  const [allowRateChart, setAllowRateChart] = useState('Not Allow')
  const [allowPayment, setAllowPayment] = useState('Not Allow')
  const [allowDues, setAllowDues] = useState('Not Allow')
  const [allowLedger, setAllowLedger] = useState('Not Allow')
  const [showDropDown1, setShowDropDown1] = useState(false)
  const [showDropDown2, setShowDropDown2] = useState(false)
  const [showDropDown3, setShowDropDown3] = useState(false)
  const [showDropDown4, setShowDropDown4] = useState(false)
  const [showDropDown5, setShowDropDown5] = useState(false)
 
  const permissionsOptions = [
    { value: 'Allow', label: 'Allow' },
    { value: 'Not Allow', label: 'Not Allow' },
  ]
  


  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible)
  }

  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible)
  }

  const navigateToPermissions = () => {
    navigator(`EditPermissions?username=${username}`)
  }

  const fetchUserData = async () => {
    try {
      console.log(username)
      if (username) {
        const res = await axios.get(`${URL}user/${username}`,{
          Authorization: `Bearer ${token}`,
        })
        console.log(res);
        setUserId(res.data.userId)
        setMobileNo(res.data.mobileNo)
        setContactPerson(res.data.contactPerson)
        setAddress(res.data.address)
        setPassword(res.data.password)
        setConfirmPassword(res.data.password)
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchUserData()
  }, [])


  const fetchUserPermissions = async () => {
    try {
      if (username) {
        const res = await axios.get(`${URL}user/${username}/permissions`,{
            Authorization: `Bearer ${token}`,
        })
        setAllowAddFarmer(res.data.allowAddFarmer)
        setAllowRateChart(res.data.allowRateChart)
        setAllowPayment(res.data.allowPayment)
        setAllowDues(res.data.allowDues)
        setAllowLedger(res.data.allowLedger)
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchUserPermissions()
  }, [])



  const updateUser = async () => {
    try {
    
      const updateResponse = await axios.put(`${URL}user/${username}`, {
        userId,
        username,
        password,
        confirmPassword,
        mobileNo,
        contactPerson,
        address,
        permissions: { allowAddFarmer, allowRateChart, allowPayment, allowDues, allowLedger },
      
      },{
        Authorization: `Bearer ${token}`,
      });
  
      if (updateResponse.status === 200) {
        alert('User updated successfully');
      } else {
        // Handle the case when the update request fails
        console.error('Error updating user:', updateResponse.status, updateResponse.statusText);
        // You may want to throw an error or handle it differently
      }
    } catch (err) {
      alert(err.response ? err.response.data.error : 'An error occurred while updating user');
      console.error(err);
    }
  };


  return (
    <div>

  

    <div className="bg-green-50 p-8">
  <div className="bg-white shadow-lg rounded-lg p-4">
    <div className="text-2xl font-bold mb-4">Edit User</div>
    <div className="space-y-4">
      <div className="flex flex-col">
        <label htmlFor="userId" className="text-gray-600">User ID</label>
        <input
          type="text"
          id="userId"
          placeholder="User ID"
          className="border rounded-md py-2 px-3"
          value={userId && userId.toString()}
          onChange={(e) => {
            setUserId(e.target.value)
          }}
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="username" className="text-gray-600">Username</label>
        <input
          type="text"
          id="username"
          placeholder="Username"
          className="border rounded-md py-2 px-3"
          value={username}
          readOnly
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="mobileNo" className="text-gray-600">Mobile No.</label>
        <input
          type="text"
          id="mobileNo"
          placeholder="Mobile No."
          className="border rounded-md py-2 px-3"
          value={mobileNo && mobileNo.toString()}
          onChange={(e) => {
            setMobileNo(e.target.value)
          }}
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="contactPerson" className="text-gray-600">Contact Person</label>
        <input
          type="text"
          id="contactPerson"
          placeholder="Contact Person"
          className="border rounded-md py-2 px-3"
          value={contactPerson}
          onChange={(e) => {
            setContactPerson(e.target.value)
          }}
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="address" className="text-gray-600">Address</label>
        <input
          type="text"
          id="address"
          placeholder="Address"
          className="border rounded-md py-2 px-3"
          value={address}
          onChange={(e) => {
            setAddress(e.target.value)
          }}
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="password" className="text-gray-600">Password</label>
        <input
          type="password"
          id="password"
          placeholder="Password"
          className="border rounded-md py-2 px-3"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
          }}
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="confirmPassword" className="text-gray-600">Confirm Password</label>
        <input
          type="password"
          id="confirmPassword"
          placeholder="Confirm Password"
          className="border rounded-md py-2 px-3"
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value)
          }}
        />
      </div>
<div className="p-4 border rounded-lg shadow-lg bg-white">
  <div className="text-xl font-semibold text-gray-800 mb-4">Select Permissions</div>
  <div className="space-y-4">
    <div className="flex items-center">
      <label htmlFor="allowAddFarmer" className="w-1/2">
        Add Farmer
      </label>
      <select
        id="allowAddFarmer"
        className="w-1/2 border rounded-md p-2"
        value={allowAddFarmer}
        onChange={(e) => setAllowAddFarmer(e.target.value)}
      >
        <option value="">Select Permission</option>
        {permissionsOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>

    <div className="flex items-center">
      <label htmlFor="allowRateChart" className="w-1/2">
        Rate Chart
      </label>
      <select
        id="allowRateChart"
        className="w-1/2 border rounded-md p-2"
        value={allowRateChart}
        onChange={(e) => setAllowRateChart(e.target.value)}
      >
        <option value="">Select Permission</option>
        {permissionsOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>

    <div className="flex items-center">
      <label htmlFor="allowPayment" className="w-1/2">
        Allow Payment
      </label>
      <select
        id="allowPayment"
        className="w-1/2 border rounded-md p-2"
        value={allowPayment}
        onChange={(e) => setAllowPayment(e.target.value)}
      >
        <option value="">Select Permission</option>
        {permissionsOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>

    <div className="flex items-center">
      <label htmlFor="allowDues" className="w-1/2">
        Allow Dues
      </label>
      <select
        id="allowDues"
        className="w-1/2 border rounded-md p-2"
        value={allowDues}
        onChange={(e) => setAllowDues(e.target.value)}
      >
        <option value="">Select Permission</option>
        {permissionsOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>

    <div className="flex items-center">
      <label htmlFor="allowLedger" className="w-1/2">
        Allow Ledger
      </label>
      <select
        id="allowLedger"
        className="w-1/2 border rounded-md p-2"
        value={allowLedger}
        onChange={(e) => setAllowLedger(e.target.value)}
      >
        <option value="">Select Permission</option>
        {permissionsOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  </div>

  <div className="mt-8">
    <button
      className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-full"
      onClick={() => updateUser()}
    >
      Update User
    </button>
  </div>
</div>

    </div>
   
  </div>
</div>

</div>




  )
}


export default EditUser